module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingle"
  }, [_c('div', {
    staticClass: " jingle_content container"
  }, [_c('h1', [_vm._v("Jingle")]), _vm._v(" "), _c('p', [_vm._v("\n      Téléchargez le Jingle pour l'inclure dans vos projets.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/OJvz0Lfe8-4",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_jingle col-lg-6 col-md-12 col-sm-12"
  }, [_c('div', {
    staticClass: "download_block"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/static/video/LogoImacJingle.mp4",
      "download": "LogoImacJingle"
    }
  }, [_vm._v("Vidéo (.mp4)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1b4d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jingle.vue
// module id = 106
// module chunks = 1